import gql from 'graphql-tag';

export default gql`
  mutation unpublishArtwork($id: ID!) {
    unpublishArtwork(id: $id) {
      id
      status
    }
  }
`;
